import Vue from 'vue'
import VueRouter from 'vue-router'
import API from './http-common.js'
import config from './config'

import Layout from './components/Layout/Layout.vue'
//main admin
import MainAdminLogin from './components/MainAdmin/Login.vue'
import MainAdminForgotPassword from './components/MainAdmin/ForgotPassword.vue'
import MainAdminResetPassword from './components/MainAdmin/ResetPassword.vue'
import MainAdminChangePassword from './components/MainAdmin/ChangePassword.vue'
import MainAdminPublicHoliday from './components/MainAdmin/PublicHoliday.vue'
import SchoolList from './components/MainAdmin/SchoolList.vue'
import SchoolEdit from './components/MainAdmin/SchoolEdit.vue'
import MainAdminErrorReport from './components/MainAdmin/ErrorReport.vue'

//school user
import SchoolUserLogin from './components/SchoolUser/Login.vue'
import SchoolUserForgotPassword from './components/SchoolUser/ForgotPassword.vue'
import SchoolUserResetPassword from './components/SchoolUser/ResetPassword.vue'
import SchoolUserMyAccount from './components/SchoolUser/MyAccount.vue'
import SchoolUserPublicHoliday from './components/SchoolUser/PublicHoliday.vue'

import InstructorMySchedule from './components/SchoolUser/Instructor/MySchedule.vue'
import InstructorMyStudents from './components/SchoolUser/Instructor/MyStudents.vue'
import InstructorMyStudentsViewDocuments from './components/SchoolUser/Instructor/MyStudentsViewDocuments.vue'
import InstructorMyDocuments from './components/SchoolUser/Instructor/MyDocuments.vue'
import InstructorStudentDocuments from './components/SchoolUser/Instructor/StudentDocuments.vue'

import StudentMyClasses from './components/SchoolUser/Student/MyClasses.vue'
import StudentMyDocuments from './components/SchoolUser/Student/MyDocuments.vue'

import OtherMyCalendar from './components/SchoolUser/Other/MyCalendar.vue'
import OtherMyDocuments from './components/SchoolUser/Other/MyDocuments.vue'

//school admin
import StudentList from './components/SchoolUser/SchoolAdmin/StudentList.vue'
import StudentEdit from './components/SchoolUser/SchoolAdmin/StudentEdit.vue'
import StudentDocument from './components/SchoolUser/SchoolAdmin/StudentDocument.vue'
import InstructorList from './components/SchoolUser/SchoolAdmin/InstructorList.vue'
import InstructorEdit from './components/SchoolUser/SchoolAdmin/InstructorEdit.vue'
import InstructorDocument from './components/SchoolUser/SchoolAdmin/InstructorDocument.vue'
import ClassSubjectList from './components/SchoolUser/SchoolAdmin/ClassSubjectList.vue'
import ClassList from './components/SchoolUser/SchoolAdmin/ClassList.vue'
import ClassEdit from './components/SchoolUser/SchoolAdmin/ClassEdit.vue'
import ClassBookingList from './components/SchoolUser/SchoolAdmin/ClassBookingList.vue'
import ClassBookingShow from './components/SchoolUser/SchoolAdmin/ClassBookingShow.vue'
import ClassBookingEdit from './components/SchoolUser/SchoolAdmin/ClassBookingEdit.vue'
import DocumentList from './components/SchoolUser/SchoolAdmin/DocumentList.vue'

//page not found
import PageNotFound from './components/PageNotFound.vue'

Vue.use(VueRouter)
let appPath = config.APP_ROOT_PATH;

const routes = [
  //main admin
  { path: appPath + 'mainadmin/login', name: 'mainAdminLogin', component: MainAdminLogin },
  { path: appPath + 'mainadmin/forgot', name: 'mainAdminForgotPassword', component: MainAdminForgotPassword },
  { path: appPath + 'mainadmin/:token/reset', name: 'mainAdminResetPassword', component: MainAdminResetPassword },
  {
    path: appPath + 'mainadmin', component: Layout, children: [
      { path: '', redirect: { name: 'schoolList' } },//default  
      { path: 'school', name: 'schoolList', component: SchoolList },
      { path: 'school/:id/show', name: 'schoolShow', component: SchoolEdit },
      { path: 'school/add', name: 'schoolAdd', component: SchoolEdit },
      { path: 'school/:id', name: 'schoolEdit', component: SchoolEdit },

      { path: 'student', name: 'mainAdminStudentList', component: StudentList },
      { path: 'student/:id/show', name: 'mainAdminStudentShow', component: StudentEdit },
      { path: 'student/add', name: 'mainAdminStudentAdd', component: StudentEdit },
      { path: 'student/:id', name: 'mainAdminStudentEdit', component: StudentEdit },
      { path: 'student/:id/document', name: 'mainAdminStudentDocument', component: StudentDocument },

      { path: 'instructor', name: 'mainAdminInstructorList', component: InstructorList },
      { path: 'instructor/:id/show', name: 'mainAdminInstructorShow', component: InstructorEdit },
      { path: 'instructor/add', name: 'mainAdminInstructorAdd', component: InstructorEdit },
      { path: 'instructor/:id', name: 'mainAdminInstructorEdit', component: InstructorEdit },
      { path: 'instructor/:id/document', name: 'mainAdminInstructorDocument', component: InstructorDocument },
      { path: 'instructor/:id/schedule', name: 'mainAdminInstructorSchedule', component: InstructorMySchedule },

      { path: 'classsubject', name: 'mainAdminClassSubjectList', component: ClassSubjectList },

      { path: 'class', name: 'mainAdminClassList', component: ClassList },
      { path: 'class/:id/show', name: 'mainAdminClassShow', component: ClassEdit },
      { path: 'class/add', name: 'mainAdminClassAdd', component: ClassEdit },
      { path: 'class/:id', name: 'mainAdminClassEdit', component: ClassEdit },

      { path: 'classbooking', name: 'mainAdminClassBookingList', component: ClassBookingList },
      { path: 'classbooking/:id/show', name: 'mainAdminClassBookingShow', component: ClassBookingShow },
      { path: 'classbooking/add', name: 'mainAdminClassBookingAdd', component: ClassBookingEdit },
      { path: 'classbooking/:id', name: 'mainAdminClassBookingEdit', component: ClassBookingEdit },
      { path: 'document', name: 'mainAdminDocumentList', component: DocumentList },

      { path: 'changepassword', name: 'mainAdminChangePassword', component: MainAdminChangePassword },
      { path: 'publicholiday', name: 'mainAdminPublicHoliday', component: MainAdminPublicHoliday },
      { path: 'errorreport', name: 'mainAdminErrorReport', component: MainAdminErrorReport }
    ], beforeEnter(to, from, next) {
      if (from.name == 'mainAdminLogin') return next();
      let data = JSON.parse(localStorage.getItem('cbstoken'))
      if (!data) return next({ name: 'mainAdminLogin' })
      API.mainAdmin.verifyMainAdminToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem("cbstoken");
          return next({ name: 'mainAdminLogin' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'mainAdminLogin' })
      })
    }
  },

  //school user
  { path: '', redirect: { name: 'schoolUserLogin' } },
  { path: appPath + 'login', name: 'schoolUserLogin', component: SchoolUserLogin },
  { path: appPath + 'forgot', name: 'schoolUserForgotPassword', component: SchoolUserForgotPassword },
  { path: appPath + ':token/reset', name: 'schoolUserResetPassword', component: SchoolUserResetPassword },
  { path: appPath + 'classbookingrequest/:id', name: 'classBookingRequest', component: ClassBookingShow },
  {
    path: appPath + 'schooladmin', component: Layout, children: [
      { path: '', redirect: { name: 'schoolAdminInstructorList' } },//default
      { path: 'mycalendar', name: 'schoolAdminMyCalendar', component: OtherMyCalendar },
      { path: 'publicholiday', name: 'schoolAdminPublicHoliday', component: SchoolUserPublicHoliday },

      { path: 'student', name: 'schoolAdminStudentList', component: StudentList },
      { path: 'student/:id/show', name: 'schoolAdminStudentShow', component: StudentEdit },
      { path: 'student/add', name: 'schoolAdminStudentAdd', component: StudentEdit },
      { path: 'student/:id', name: 'schoolAdminStudentEdit', component: StudentEdit },
      { path: 'student/:id/document', name: 'schoolAdminStudentDocument', component: StudentDocument },

      { path: 'instructor', name: 'schoolAdminInstructorList', component: InstructorList },
      { path: 'instructor/:id/show', name: 'schoolAdminInstructorShow', component: InstructorEdit },
      { path: 'instructor/add', name: 'schoolAdminInstructorAdd', component: InstructorEdit },
      { path: 'instructor/:id', name: 'schoolAdminInstructorEdit', component: InstructorEdit },
      { path: 'instructor/:id/document', name: 'schoolAdminInstructorDocument', component: InstructorDocument },
      { path: 'instructor/:id/schedule', name: 'schoolAdminInstructorSchedule', component: InstructorMySchedule },

      { path: 'classsubject', name: 'schoolAdminClassSubjectList', component: ClassSubjectList },

      { path: 'class', name: 'schoolAdminClassList', component: ClassList },
      { path: 'class/:id/show', name: 'schoolAdminClassShow', component: ClassEdit },
      { path: 'class/add', name: 'schoolAdminClassAdd', component: ClassEdit },
      { path: 'class/:id', name: 'schoolAdminClassEdit', component: ClassEdit },

      { path: 'classbooking', name: 'schoolAdminClassBookingList', component: ClassBookingList },
      { path: 'classbooking/:id/show', name: 'schoolAdminClassBookingShow', component: ClassBookingShow },
      { path: 'classbooking/add', name: 'schoolAdminClassBookingAdd', component: ClassBookingEdit },
      { path: 'classbooking/:id', name: 'schoolAdminClassBookingEdit', component: ClassBookingEdit },
      { path: 'document', name: 'schoolAdminDocumentList', component: DocumentList },

      { path: 'changepassword', name: 'schoolAdminChangePassword', component: MainAdminChangePassword }
    ],
    beforeEnter(to, from, next) {
      if (from.name == 'schoolUserLogin') return next();
      let data = JSON.parse(localStorage.getItem('cbstoken'))
      if (!data) return next({ name: 'schoolUserLogin' })
      API.schoolUser.verifySchoolUserToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem("cbstoken");
          return next({ name: 'schoolUserLogin' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'schoolUserLogin' })
      })
    }
  },
  {
    path: appPath + 'instructor', component: Layout, children: [
      { path: '', redirect: { name: 'instructorMySchedule' } },
      { path: 'myaccount', name: 'instructorMyAccount', component: SchoolUserMyAccount },
      { path: 'myschedule', name: 'instructorMySchedule', component: InstructorMySchedule },
      { path: 'publicholiday', name: 'instructorPublicHoliday', component: SchoolUserPublicHoliday },
      { path: 'myassignedclass', name: 'instructorMyAssignedClass', component: ClassList },
      { path: 'myassignedclass/:id/show', name: 'instructorMyAssignedClassShow', component: ClassEdit },
      { path: 'classbooking/add', name: 'instructorClassBookingAdd', component: ClassBookingEdit },
      { path: 'mystudents', name: 'instructorMyStudents', component: InstructorMyStudents },
      { path: 'mystudents/:id/show', name: 'instructorMyStudentShow', component: StudentEdit },
      { path: 'mystudents/:id/viewdocuments', name: 'instructorMyStudentsViewDocuments', component: InstructorMyStudentsViewDocuments },
      { path: 'mydocuments', name: 'instructorMyDocuments', component: InstructorMyDocuments },
      { path: 'studentdocuments', name: 'instructorStudentDocuments', component: InstructorStudentDocuments },
      { path: 'changepassword', name: 'instructorChangePassword', component: MainAdminChangePassword }
    ],
    beforeEnter(to, from, next) {
      if (from.name == 'schoolUserLogin') return next();
      let data = JSON.parse(localStorage.getItem('cbstoken'))
      if (!data) return next({ name: 'schoolUserLogin' })
      API.schoolUser.verifySchoolUserToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem("cbstoken");
          return next({ name: 'schoolUserLogin' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'schoolUserLogin' })
      })
    }
  },
  {
    path: appPath + 'other', component: Layout, children: [
      { path: '', redirect: { name: 'otherMyCalendar' } },
      { path: 'myaccount', name: 'otherMyAccount', component: SchoolUserMyAccount },
      { path: 'mycalendar', name: 'otherMyCalendar', component: OtherMyCalendar },
      { path: 'publicholiday', name: 'otherPublicHoliday', component: SchoolUserPublicHoliday },
      { path: 'mydocuments', name: 'otherMyDocuments', component: OtherMyDocuments },
      { path: 'changepassword', name: 'otherChangePassword', component: MainAdminChangePassword }
    ],
    beforeEnter(to, from, next) {
      if (from.name == 'schoolUserLogin') return next();
      let data = JSON.parse(localStorage.getItem('cbstoken'))
      if (!data) return next({ name: 'schoolUserLogin' })
      API.schoolUser.verifySchoolUserToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem("cbstoken");
          return next({ name: 'schoolUserLogin' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'schoolUserLogin' })
      })
    }
  },
  {
    path: appPath + 'student', component: Layout, children: [
      { path: '', redirect: { name: 'studentClassBookingForm' } },
      { path: 'myaccount', name: 'studentMyAccount', component: SchoolUserMyAccount },
      { path: 'classbookingform', name: 'studentClassBookingForm', component: ClassBookingEdit },
      { path: 'publicholiday', name: 'studentPublicHoliday', component: SchoolUserPublicHoliday },
      { path: 'myclasses', name: 'studentMyClasses', component: StudentMyClasses },
      { path: 'mydocuments', name: 'studentMyDocuments', component: StudentMyDocuments },
      { path: 'classavailability', name: 'studentClassAvailability', component: ClassList },
      { path: 'classavailability/:id/show', name: 'studentClassAvailabilityShow', component: ClassEdit },
      { path: 'changepassword', name: 'studentChangePassword', component: MainAdminChangePassword }
    ],
    beforeEnter(to, from, next) {
      if (from.name == 'schoolUserLogin') return next();
      let data = JSON.parse(localStorage.getItem('cbstoken'))
      if (!data) return next({ name: 'schoolUserLogin' })
      API.schoolUser.verifySchoolUserToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem("cbstoken");
          return next({ name: 'schoolUserLogin' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'schoolUserLogin' })
      })
    }
  },

  { path: '*', name: 'pageNotFound', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router.js